import { InfluencerInstagramProfileTags, InfluencerInstagramProfileTagsProps } from '../../InfluencerProfiles';

type InfluencerAnalyticsInstagramProfileTagsProps = InfluencerInstagramProfileTagsProps;

export const InfluencerAnalyticsInstagramProfileTags = (props: InfluencerAnalyticsInstagramProfileTagsProps) => (
  <InfluencerInstagramProfileTags {...props} />
);
